module.exports = __webpack_public_path__ + "static/media/phone.b60cd37a.png";